const root = 'FeaturesTable'

export const TestId = {
  root,
}
